<script>
export default {
    name: 'ServicePlanFeatureUpdateMatched',
};
</script>

<script setup>
import ServicePlanFeatureElementsBoolean
    from '@/components/payments/components/service-plan/components/features/components/elements/boolean.vue';

defineProps({
    feature: {
        type:     Object,
        required: true,
    },
    short:   {
        type: Boolean,
    },
});
</script>

<template>
    <service-plan-feature-elements-boolean
        :feature="feature"
        :name="short ? undefined : 'Update matched'"
    />
</template>
